const useNavigateToBack = async () => {
  const route = useRoute();
  const router = useRouter();
  const { closeModal, isModalOpen } = useModalStore();
  const { isMenuVisible, toggleMenu } = useAppStore();

  if (isModalOpen()) {
    closeModal();

    return;
  }

  if (isMenuVisible.value) {
    toggleMenu(false);
    // Также разблокируем скролл страницы
    if (typeof pageScrollUnblock === "function") {
      pageScrollUnblock();
    }
    return;
  }

  // Проверяем, находимся ли мы на странице услуг с примененным фильтром
  if (route.path === "/records/online/services" && route.query.category) {
    await router.replace({
      path: route.path,
      query: {},
    });

    window.dispatchEvent(new CustomEvent("resetServiceFilters"));

    return;
  }

  if ("backUrl" in route.meta && typeof route.meta.backUrl === "string") {
    await router.replace(route.meta.backUrl);

    return;
  }

  if (window.history.length > 1) {
    router.back();

    return;
  }

  if ("backUrlSafe" in route.meta && typeof route.meta.backUrlSafe === "string") {
    await router.replace(route.meta.backUrlSafe);

    return;
  }

  await router.replace("/");
};

export { useNavigateToBack };
